import { createStore, combineReducers } from 'redux';
import checksSyncReducer from './reducers/checks-sync-reducer';
import { updateChecks, deleteChecks, clearChecks, updateSyncStatus } from './actions/sync-actions';
import syncStateReducer from './reducers/sync-status-reducer';

const rootReducerCheckUpdates = combineReducers({
  checksSyncState: checksSyncReducer,
  syncStatus: syncStateReducer,
});

const syncStore = createStore(rootReducerCheckUpdates);

export default syncStore;

function dispatchUpdateChecks(check) {
  syncStore.dispatch(updateChecks(check));
}

function dispatchDeleteChecks(checkHeaderId) {
  syncStore.dispatch(deleteChecks(checkHeaderId));
}

function dispatchClearChecks() {
  syncStore.dispatch(clearChecks());
}

function dispatchUpdateSyncStatus(status: string) {
  syncStore.dispatch(updateSyncStatus(status));
}

export {
  dispatchUpdateChecks,
  dispatchDeleteChecks,
  dispatchClearChecks,
  dispatchUpdateSyncStatus,
};
